import { Link } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { ArrowRight } from "lucide-react";
import { Logo } from "@/components/AppLayout";

const VIDEO = window.matchMedia("(max-width: 767px)").matches ? "/promo/windworkhub_companies_vertical.mp4" : "/promo/windworkhub_companies.mp4";

const Cta = ({ to, testId }) => (
  <Link to={to} data-testid={testId}
    className="inline-flex items-center gap-2 px-7 py-4 rounded bg-amber-400 hover:bg-amber-300 text-slate-950 font-bold text-lg transition-colors">
    Post a job for free<ArrowRight size={18} />
  </Link>
);

export default function Companies() {
  const { isSignedIn } = useAuth();
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
          <Logo />
          <Link to="/sign-in" className="text-sm font-medium text-slate-600 hover:text-slate-900" data-testid="companies-signin-link">Sign in</Link>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 py-10 md:py-16 grid md:grid-cols-[1fr_minmax(0,520px)] gap-10 items-center">
        <div>
          <p className="eyebrow">For wind companies</p>
          <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight" data-testid="companies-title">Hire certified wind turbine technicians.</h1>
          <div className="mt-8"><Cta to={isSignedIn ? "/jobs/new" : "/sign-up"} testId="companies-cta" /></div>
        </div>
        <video src={VIDEO} autoPlay muted loop playsInline data-testid="companies-video"
          className="w-full max-w-[420px] md:max-w-none mx-auto rounded-xl shadow-2xl bg-slate-900" />
      </main>
    </div>
  );
}
